interface VaultVersion {
  integrationType?: string | null;
  integration?: { externalVersionId?: string | null; version?: string | null } | null;
}

export const getVaultDocumentUrl = (
  version: VaultVersion | undefined,
  domain: string | null | undefined,
): string | undefined => {
  if (version?.integrationType !== 'VEEVA' || !version.integration?.externalVersionId || !domain?.trim()) return;
  const externalId = version.integration.externalVersionId.split('_')[0];
  if (!externalId) return;

  try {
    const host = domain.trim();
    const url = new URL(host.includes('://') ? host : `https://${host}`);
    if (url.protocol !== 'https:' || url.username || url.password || url.port ||
      url.pathname !== '/' || url.search || url.hash) return;
    url.pathname = '/ui/';
    const sourceVersion = version.integration.version;
    const versionParts = sourceVersion?.includes('_')
      ? sourceVersion.split('_').slice(-2)
      : sourceVersion?.split('.');
    const versionPath = versionParts?.length === 2
      ? `/${versionParts.map(encodeURIComponent).join('/')}`
      : '';
    url.hash = `doc_info/${encodeURIComponent(externalId)}${versionPath}`;
    return url.toString();
  } catch {
    return undefined;
  }
};
